import type { ReactElement, SVGProps } from 'react';

export function IconIsometricFlagNl(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 40 40"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.3971 16.7124L34.4156 23.7309L8.22562 38.8483L8.20715 31.8298L34.3971 16.7124Z"
        fill="#077EE0"
      />
      <path
        d="M8.20713 31.8297L5.60291 30.3152L31.7929 15.1978L34.3971 16.7123L8.20713 31.8297Z"
        fill="#FFD000"
      />
      <path
        d="M34.3786 9.67535L34.4156 16.6938L8.20713 31.8205L8.18866 24.802L34.3786 9.67535Z"
        fill="white"
      />
      <path
        d="M8.18863 24.8021L5.58441 23.2875L31.7744 8.16089L34.3786 9.6754L8.18863 24.8021Z"
        fill="#E02D2D"
      />
      <path
        d="M34.3602 2.65704L34.3787 9.67551L8.1887 24.8022L8.17023 17.7745L34.3602 2.65704Z"
        fill="#E02D2D"
      />
      <path
        d="M5.60297 30.3154L5.62144 37.3338L8.22566 38.8483L8.20719 31.8299L5.60297 30.3154Z"
        fill="#050505"
      />
      <path
        d="M8.20714 31.8206L8.18867 24.8021L8.1702 17.7744L34.3602 2.65697L31.756 1.14246L5.56598 16.2599L5.58445 23.2876L5.60292 30.306L8.20714 31.8206Z"
        fill="#050505"
      />
      <path
        d="M34.0579 23.5144L16.636 33.574L8.59894 38.2087L8.54523 17.9988L16.9554 13.1404L33.9964 3.30542L34.0579 23.5144Z"
        stroke="#050505"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.75"
      />
    </svg>
  );
}
